let _canvas: HTMLCanvasElement | null = null
let _canvasFont = ""

/**
 * Measures the rendered pixel width of a text string using a canvas context.
 * Useful for computing how much space text will take before it's in the DOM.
 */
export function measureTextWidth(text: string, font: string): number {
  if (!_canvas) _canvas = document.createElement("canvas")
  const ctx = _canvas.getContext("2d")!
  if (_canvasFont !== font) {
    ctx.font = font
    _canvasFont = font
  }
  return ctx.measureText(text).width
}
